export const CONFIRM_MODAL_ACCEPT = 'Confirmar';
export const CONFIRM_MODAL_DECLINE = 'Cancelar';
